<template>
    <v-dialog
        v-model="dialog"
        :max-width="options.width"
        @keydown.esc="cancel"
    >
        <v-card>
            <v-card-title>
                {{ title }}
            </v-card-title>
            <v-card-text
                class="pa-4 black--text"
            >
                <div
                    v-html="message"
                />
                <slot/>
            </v-card-text>
            <v-card-actions
                class="pt-3"
            >
                <v-spacer/>
                <v-btn
                    v-if="!options.noConfirm"
                    text
                    outlined
                    @click="cancel"
                >
                    {{ options.cancelOptionLabel || $t('action.cancel') }}
                </v-btn>
                <v-btn
                    color="primary"
                    @click="agree"
                >
                    {{ options.confirmOptionLabel || $t('action.ok') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    data: () => ({
        dialog: false,
        resolve: null,
        reject: null,
        message: null,
        title: null,
        options: {
            color: 'grey lighten-3',
            width: 400,
            zIndex: 200,
            noConfirm: false,
            cancelOptionLabel: null,
            confirmOptionLabel: null
        },
    }),
    methods: {
        open(
            title,
            message,
            options
        ) {
            this.dialog = true;
            this.title = title;
            this.message = message;
            this.options = Object.assign(
                this.options,
                options
            );

            return new Promise((resolve, reject) => {
                this.resolve = resolve;
                this.reject = reject;
            });
        },
        agree() {
            this.resolve(true);
            this.dialog = false;
        },
        cancel() {
            this.resolve(false);
            this.dialog = false;
        },
    },
}
</script>
